const primary = "https://cdn.kitsos.net";
const fallbacks = ["https://cdn2.kitsos.net", "https://cdn3.kitsos.net"];
const storageKey = "kitsos.cdn.host";
let resolved: Promise<string> | null = null;

function candidates() {
  const cached = sessionStorage.getItem(storageKey);
  const shuffled = [...fallbacks].sort(() => Math.random() - 0.5);
  return [...new Set([cached, primary, ...shuffled].filter((value): value is string => Boolean(value)))];
}

async function healthy(host: string) {
  const controller = new AbortController();
  const timeout = window.setTimeout(() => controller.abort(), 1800);
  try {
    const response = await fetch(`${host}/health/asset-probe.txt`, { cache: "no-store", signal: controller.signal });
    return response.ok;
  } catch {
    return false;
  } finally {
    window.clearTimeout(timeout);
  }
}

export function resolveCdnHost() {
  resolved ??= (async () => {
    for (const host of candidates()) {
      if (await healthy(host)) {
        sessionStorage.setItem(storageKey, host);
        return host;
      }
    }
    return primary;
  })();
  return resolved;
}

export async function loadCdnFonts() {
  const host = await resolveCdnHost();
  if (document.querySelector("link[data-kitsos-fonts]")) return;
  const stylesheet = document.createElement("link");
  stylesheet.rel = "stylesheet";
  stylesheet.href = `${host}/fonts/fonts.css`;
  stylesheet.dataset.kitsosFonts = "true";
  document.head.append(stylesheet);
}
